import SearchResults from '../containers/content/search/results'

/**
 * URL: /search/:content?q=foo
 *
 * /search?q=foo
 * /search/videos?q=foo
 * /search/documents?q=foo
 *
 * @urlParams
 * :content indicates which tab is active in UI,
 * (if empty defaults to 'all' tab.)
 *
 * @queryParams
 * q: search query
 */
const SearchPage = () => {
  return <SearchResults basePath='search' />
}

export default SearchPage
